/** Per-device notification mute: silences the chime and toasts, not the badge. Keep in sync with windows_pos. */
const KEY = 'notifications_muted';

export const isMuted = () => {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
};

export const setMuted = (muted) => {
  try { localStorage.setItem(KEY, muted ? '1' : '0'); } catch { /* private mode — session-only */ }
  // Announced so any mounted control can mirror the new state.
  window.dispatchEvent(new CustomEvent('notify-mute-changed', { detail: !!muted }));
};
